import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Input } from '@angular/core';
import { Router } from '@angular/router';
import { Temporal } from '@js-temporal/polyfill';
import { ReviewTypeEnum } from 'src/app/enums/review-type.enum';
import { AssessmentHelper } from 'src/app/helpers/assessment.helper';
import { ReviewPeriodHelper } from 'src/app/helpers/review-period.helper';
import { Employee } from 'src/app/models/employee.model';
import { ReviewPeriodForEmployee } from 'src/app/models/review-period-for-employee.model';
import { ReviewPeriodService } from 'src/app/services';
import { DateHelper } from 'src/app/shared/helpers';
import { ErrorMessageService } from 'src/app/shared/services';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-assessment-list-item',
  templateUrl: './assessment-list-item.component.html',
  styleUrl: './assessment-list-item.component.scss'
})
export class AssessmentListItemComponent {
  @Input() public item: ReviewPeriodForEmployee;
  @Input() public employee: Employee;
  public expanded = false;
  public loaded = false;
  public isProgress = false;

  @Input() public closedGroup = false;

  isSziluett = ReviewPeriodHelper.isSziluett;
  isMilio = ReviewPeriodHelper.isMilio;
  isPanorama = ReviewPeriodHelper.isPanoramaAuraGoals;
  isRpOpen = ReviewPeriodHelper.isRpOpen;
  isRpClosed = ReviewPeriodHelper.isRpClosed;
  isRpeFinished = AssessmentHelper.isRpeFinished;

  constructor(
    private router: Router,
    private msgService: ErrorMessageService,
    private reviewPeriodService: ReviewPeriodService,
    private cd: ChangeDetectorRef,
    private translate: TranslateService
  ) {

    }

  getCategoryName(rpForEmployee: ReviewPeriodForEmployee): string {
      if (rpForEmployee.reviewPeriod.reviewType == ReviewTypeEnum.PersonalityTest)
          return this.translate.instant('ASSESSMENT_LIST_ITEM.SZILUETT_LONG_TITLE');
      else
          return this.reviewPeriodService.getName(rpForEmployee.reviewPeriod.reviewType);
  }

  getItemName(rpForEmployee: ReviewPeriodForEmployee): string {
      if (rpForEmployee.reviewPeriod.reviewType == ReviewTypeEnum.PersonalityTest && rpForEmployee.reviewPeriod.name == "2.0")
          return this.translate.instant('ASSESSMENT_LIST_ITEM.SZILUETT_VERSION');
      else
          return rpForEmployee.reviewPeriod.name;
  }

  isDateExpired(date: Temporal.PlainDate): boolean {
    if (!date) return false;
    
    return DateHelper.isDateExpired(date);
  }

  getClosedOrExpirationDateRpe(): Temporal.PlainDate {
    return this.item.isRpeClosed ? this.item.reviewPeriodEmployee.endDate : this.item.reviewPeriodEmployee.deadline;
  }

  // ha nincs kitöltve akkor a határidő, egyébként a reviewPeriod kijelölt vége
  getRpeDeadline(): Temporal.PlainDate {
    return this.item.reviewPeriodEmployee.deadline ?? this.item.reviewPeriod.endDate;
  }

  // kitöltés dátuma
  getReviewDate(): Date {
    return this.item.reviewPeriodEmployee.closedOn;
  }

  loadAssessmentPage() {
    this.router.navigate(AssessmentHelper.getAssessmentLink(this.item.reviewPeriodEmployee.reviewPeriodEmployeeId));       
  }

  changeExpand() {
    this.expanded = !this.expanded;
    if (this.expanded && !this.loaded) {
        this.loaded = true;
    }
  }

  detailsLoading(loading: boolean) {
    if (loading) {
      this.isProgress = true;
      this.cd.detectChanges();
    } else {
      // késleltetve tüntetjük el
      setTimeout(() => this.isProgress = false, 500);
    }
  }
  
}
